import React, { useState, useEffect } from "react";
import { BuildNumberContext } from "psg-react-components";

import { FocusStyleManager } from "@blueprintjs/core";

import { defaultSettings, SettingsContext } from "utils/context";
import useLocalStorage from "hooks/useLocalStorage";
import ConsoleNavbar from "components/Navbar/ConsoleNavbar";

FocusStyleManager.onlyShowFocusOnTabs();

export default function App() {
    const [buildNumber, setBuildNumber] = useState("");
    useEffect(() => {
        document.body.classList.add("bp3-dark");
    }, []);
    useEffect(() => {
        async function getBuildNumber() {
            try {
                const response = await fetch("/buildInfo.json");
                const buildInfo = await response.json();

                if (buildInfo?.BuildNumber) {
                    setBuildNumber(buildInfo.BuildNumber);
                    console.log(`Build Number: ${buildInfo.BuildNumber}`);
                }
            } catch (error) {
                console.error("buildInfo.json error", error);
            }
        }

        getBuildNumber();
    }, []);
    const settingsTuple = useLocalStorage("settings", defaultSettings);

    return (
        <BuildNumberContext.Provider value={buildNumber}>
            <SettingsContext.Provider value={settingsTuple}>
                <ConsoleNavbar />
            </SettingsContext.Provider>
        </BuildNumberContext.Provider>
    );
}
